import React from 'react'
import Stack from './stack'

interface IProgressProps extends React.HTMLProps<HTMLDivElement> {
  value?: number
  showLabel?: boolean
}

const Progress: React.FC<IProgressProps> = ({ value = 0, showLabel }) => (
  <Stack block align='center' className='progress-wrapper'>
    <div className='progress'>
      <div
        className={`progress-content ${
          value >= 1 ? 'progress-content-done' : ''
        }`}
        style={{ width: `${value * 100}%` }}
      />
    </div>
    {showLabel && <p>{value * 100}%</p>}
  </Stack>
)

export default Progress
